import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  OPTIMIZELY_FEATURE_FLAGS_KEYS,
  PARTNER_DASHBOARD_SERVICE_PRICING_PROOF,
} from 'components/Optimizely/Optimizely.features';
import { isFeatureEnabledForUser } from 'components/Optimizely/Optimizely.sdk';

import { reportError } from 'helpers/error-logging';

import { selectUserId } from 'selectors/general';

export function useIsServicePricingProofEnabled() {
  const userId = useSelector(selectUserId);
  const [isPricingProofEnabled, setIsPricingProofEnabled] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadPricingProofFlag() {
      try {
        const enabled = await isFeatureEnabledForUser(
          OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNER_DASHBOARD_SERVICE_PRICING_PROOF],
          userId
        );

        if (isMounted) setIsPricingProofEnabled(enabled);
      } catch (error) {
        // Fail closed: on a flag-resolution error keep the safe (off) default.
        reportError('Failed to resolve service-pricing-proof flag', { error, userId });
        if (isMounted) setIsPricingProofEnabled(false);
      }
    }

    if (userId) {
      loadPricingProofFlag();
    } else {
      setIsPricingProofEnabled(false);
    }

    return () => {
      isMounted = false;
    };
  }, [userId]);

  return isPricingProofEnabled;
}
